<div class="modal-footer" style="padding: 0.5rem;">
  <button
    type="button"
    class="btn btn-default"
    [disabled]="cancelDisabled"
    (click)="onCancelClick.emit()"
  >
    {{ cancelLabel }}
  </button>
  <button type="submit" class="btn btn-warning" *ngIf="showSaveButtonOther" (click)="saveOther()" [disabled]="saveOtherDisabled">
    {{ saveOtherLabel }}
  </button>
  <button type="submit" class="btn btn-primary" *ngIf="showSaveButton" (click)="save()" [disabled]="saveDisabled">
    {{ saveLabel }}
  </button>
</div>
